import React,{ useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import _ from "lodash";
import { Dialog } from "primereact/dialog";
import { Sidebar } from "primereact/sidebar";
import { SplitButton } from 'primereact/splitbutton';
import { TabPanel, TabView } from "primereact/tabview";

import Table  from "../../helpers/Table";
import Button from "../../helpers/Button";
import Menu from "../../helpers/Menu"

import CopyToClipboard from "../../common/CopyToClipboard";
import PMUserName from "../../common/PMUserName";
import PMCompanyName from "../../common/PMCompanyName";
import ButtonGroup from "../../common/ButtonGroup";

import PIReceivedProductDetails from "../SellerPO/Components/PIReceivedProductDetails";
import PaymentHistory from "../VendorPaymentSummary/components/PaymentHistory";
import DownlaodPaymentTrackerModal from "./Components/DownloadPaymentTracker";
import AddExpense from "./Components/AddExpense";
import Search from "./Components/Search";

import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchSellerPOVendorPayments, setIsSearchVisible } from "../../services/redux/reducers/vendorPayment/vendorPayment";
import { fetchCompanyCreditPeriods, fetchHSNMasterData, fetchMaterialBrands, fetchStatus } from "../../services/redux/reducers/commonThunk";
import { getSellerPIPunchBySellerPOId } from "../../services/api/sellerPIPunch";
import { getMaterialMasterAndTempMaterialIds } from "../../services/api/materialMaster";
import { getExpenseCategories } from "../../services/api/expenseCategories";

import "./index.css";

import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import { round, numberConversion, getCompanyShortName, isMobile } from "../../utils";
import { DATE_TIME_FORMAT, SELLERPO_VP_MIN_PRICE_DIFF } from "../../constants";


const VendorPayment = () => {
    const [visibleAddExpense, setVisibleAddExpense] = useState(false)
    const [isPIVisible, setIsPIVisible] = useState(false)
    const [isBankDetailsVisible, setIsBankDetailsVisible] = useState(false)
    const [isVendorPaymentHistoryVisible, setIsVendorPaymentHistoryVisible] = useState(false)
    const [visiblePaymentTrackerModal, setVisiblePaymentTrackerModal] = useState(false)

    const [expenseCategories, setExpenseCategories] = useState([])
    const [displayedBankDetails, setDisplayedBankDetails] = useState([])
    const [displayedVendorPayments, setDisplayedVendorPayments] = useState([])
    const [sellerPIPunch, setSellerPIPunch] = useState([])
    const [sellerPIPunchItems, setSellerPIPunchItems] = useState([])
    const [PIPunchBookingLogs, setPIPunchBookingLogs] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const isTableLoading = useSelector(state => state.vendorPaymentsSellerPO.loading)
    const searchParams = useSelector(state => state.vendorPaymentsSellerPO.searchParams)
    const paginationParams = useSelector(state => state.vendorPaymentsSellerPO.paginationParams)
    const sellerPOVendorPaymentsData = useSelector(state => state.vendorPaymentsSellerPO.sellerPOVendorPaymentsData)
    const materialBrands = useSelector(state => state.common.materialBrands)
    const vendorPayments = useSelector(state => state.vendorPaymentsSellerPO.vendorPayments)
    const companyBankAccounts = useSelector(state => state.vendorPaymentsSellerPO.companyBankAccounts)
    const isSearchVisible = useSelector(state => state.vendorPaymentsSellerPO.isSearchVisible)
    const isSearchActive = useSelector(state => state.vendorPaymentsSellerPO.isSearchActive)

    const HSNMasterData = useSelector(state => state.common.HSNMaster)
    const companyCreditPeriods = useSelector((state) => state.common.companyCreditPeriods)
    const statusList = useSelector((state) => state.common.status)

    const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const actionMenu = useRef(null)

    const dispatch = useDispatch()

    const isMobileDevice = isMobile()

    useEffect(() => {
        dispatch(fetchStatus())
        fetchPettyCashCategories()
    }, [])

    useEffect(() => {
        dispatch(fetchMaterialBrands())
        dispatch(fetchHSNMasterData())
        dispatch(fetchCompanyCreditPeriods())
    }, [sellerPOVendorPaymentsData])

    const fetchPettyCashCategories = async () => {
		const response = await getExpenseCategories()
		if (response?.failure){
			dispatch(raiseToast({severity:'error', summary: 'Expense Categories', detail: response.data.error , life: 3000}))
		}

		let sortedExpenseCategories = _.sortBy(response.data, "expenseCategoryName")
		setExpenseCategories(sortedExpenseCategories)
	}

    const getKAMBody = (row)=>{
        let kamName = row["users.firstName"] 

        if(row["users.lastName"]){
            kamName = kamName + " " + row["users.lastName"]
        }
        return <PMUserName userName={kamName} userId={row.createdBy}/>
    }

    const getSellerCompanyName = (row)=>{
        let companyName = getCompanyShortName(row["companies.companyName"])
        let companyId = row["companyId"]

        return <PMCompanyName companyName={companyName} companyId={companyId}/>
    }

    const getBuyerCompanyName = (row)=>{
        let companyName = getCompanyShortName(row["buyerPO.companies.companyName"])
        let companyId = row["buyerPO.companies.companyId"]

        return <PMCompanyName companyName={companyName} companyId={companyId}/>
    }

    const getDocNo = (row) => {
        const date = moment(row.createdAt).format(DATE_TIME_FORMAT)
        const relatedExpenseCategory = expenseCategories.find(eachCategory => eachCategory.expenseCategoryId === row.expenseCategoryId)

        return (
            <div className='req-no-container' style={{position: "relative"}}>
                {
                    row.expenseCategoryId ? 
                        <>  
                            <span style={{fontSize: "12px", fontWeight: "bold"}}>EXPENSE</span>
                            <br />
                            <span style={{fontSize: "12px"}}>{relatedExpenseCategory?.expenseCategoryName}</span>
                        </> 
                        : null
                }
                <div className='flex flex-row justify-content-center align-items-center'>
                    {
                        row?.docNo ? 
                        <>
                            <CopyToClipboard text={row.docNo} />
                            <p className='doc-no' style={{cursor: "pointer"}} onClick={() => window.open(`/sellerpo/${row?.sellerPOId}`)} >{row.docNo}</p>
                            {row.mongoSellerPOId ? <i className="pi pi-external-link pl-1 doc-copy-icon" onClick={() => window.open(`https://app.procmart.com/admin/sellerpo/${row.mongoSellerPOId}`, "_blank")} ></i> : null}
                        </>
                        : ""
                    } 
                </div>
                <p className='date'>{date}</p>
            </div>
        )
    }

    const getPurchaseInvBody = (row)=>{
        return(
            <div>
                <Button label="View" className="small-btn" onClick={() => handlePIView(row)}/>
            </div>
        )
    }

    const renderVendorPaymentRequestButton = (row) => {
        const relatedVendorPayments = vendorPayments.filter(eachVendorPayment => eachVendorPayment.sellerPOId === row.sellerPOId)

        const items = [
            {
                label: 'View',
                icon: 'pi pi-eye',
                command: () => { 
                    setIsVendorPaymentHistoryVisible(true) 
                    setDisplayedVendorPayments(relatedVendorPayments)
                }
            },
            {
                label: 'Request',
                icon: 'pi pi-external-link',
                command: () => { window.open(`/vendor_payment_summary/${row?.sellerPOId}`, '_blank') }
            },
        ]

        const save = () => {
            window.open(`/vendor_payment_summary/${row?.sellerPOId}`, '_blank')
        }

        return(
            <div>
                <SplitButton label="Request" className="small-split-btn" onClick={save} model={items} />
            </div>
        )
    }

    const getPaidAmount = (row) => {
        const relatedVendorPayments = vendorPayments.filter(eachVendorPayment => eachVendorPayment.sellerPOId === row.sellerPOId)

        let totalPaidAmount = 0
        relatedVendorPayments.map(eachVendorPayment => {
            if(eachVendorPayment.statusId === 10){
                totalPaidAmount += eachVendorPayment.amount 
                if(eachVendorPayment.tdsAmount){
                    totalPaidAmount += eachVendorPayment.tdsAmount
                }
            }
        })

        return numberConversion(round(totalPaidAmount), numberLocale)
    }

    const getDueAmount = (row) => {
        const relatedVendorPayments = vendorPayments.filter(eachVendorPayment => eachVendorPayment.sellerPOId === row.sellerPOId)

        let totalPaidAmount = 0
        relatedVendorPayments.map(eachVendorPayment => {
            if(eachVendorPayment.statusId === 10){
                totalPaidAmount += eachVendorPayment.amount 
                if(eachVendorPayment.tdsAmount){
                    totalPaidAmount += eachVendorPayment.tdsAmount
                }
            }
        })
        totalPaidAmount = round(totalPaidAmount)

        return numberConversion(round(row.totalPOAmount - totalPaidAmount), numberLocale)
    }

    const getVPStatus = (row) => {
        const relatedVendorPayments = vendorPayments.filter(eachVendorPayment => eachVendorPayment.sellerPOId === row.sellerPOId)

        let totalPaidAmount = 0
        let requestedPaymentExists = false
        relatedVendorPayments.map(eachVendorPayment => {
            if(eachVendorPayment.statusId === 10){
                totalPaidAmount += eachVendorPayment.amount 
                if(eachVendorPayment.tdsAmount){
                    totalPaidAmount += eachVendorPayment.tdsAmount
                }
            }
            if(eachVendorPayment.statusId === 12){
                requestedPaymentExists = true
            }
        })

        let amountDue = round(row.totalPOAmount - totalPaidAmount)

        if(row.statusId === 4){
            return "Closed"
        } else if(row.statusId === 13){
            return "VP Paused"
        } else if(relatedVendorPayments.length == 0){
            return "Not Initiated"
        } else if(requestedPaymentExists){
            return "Awaiting Approval"
        } else if(amountDue <= SELLERPO_VP_MIN_PRICE_DIFF){
            return "Completed"
        } else {
            return "Pending"
        }
    }

    const handleBankDetailsView = (row) => {
        const relatedBankAccounts = companyBankAccounts?.filter(eachBankDetails => eachBankDetails.branchId?.includes(row.branchId))
        setIsBankDetailsVisible(true)
        setDisplayedBankDetails(relatedBankAccounts)
    }

    const getBankDetailsBody = (row)=>{
        const relatedBankDetails = companyBankAccounts?.filter(eachBankDetails => eachBankDetails.branchId?.includes(row.branchId))
        return(
            <div>
                {
                    relatedBankDetails?.length > 0 ?
                    (
                        <a style={{cursor: "pointer", textDecoration: "underline"}} onClick={() => handleBankDetailsView(row)} > View </a>
                    ): "-"
                }
            </div>
        )
    }

    const getTotalPOAmount = (row) => {
        return numberConversion(parseFloat(row.totalPOAmount), numberLocale)
    }

    const getTotalPOTax = (row) => {
        return numberConversion(parseFloat(row.totalPOTax), numberLocale)
    }

    const tableColumns = [
        {
            header : 'Document No.', body: getDocNo , style:{ textAlign: "center" }
        },
        {
            header : 'Seller Company', body: getSellerCompanyName, style:{ textAlign: "center",  minWidth: "150px"}
        },
        {
            header: 'KAM', field: '', body: getKAMBody, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header : 'Buyer Company', body: getBuyerCompanyName, style:{ textAlign: "center", minWidth: "150px"}
        },
        {
            header: 'Total Amount', field: 'totalPOAmount', body: getTotalPOAmount, style:{ textAlign: "center", minWidth: "90px" }
        },
        /*{
            header: 'TDS', field: 'tds', style:{ textAlign: "center" }
        },
        {
            header: 'TCS', field: 'tcs', style:{ textAlign: "center" }
        },*/
        {
            header: 'Tax Amount', field: 'totalPOTax', body: getTotalPOTax, style:{ textAlign: "center", minWidth: "90px" }
        },
        {
            header: 'Amount Paid', body: getPaidAmount, style:{ textAlign: "center", minWidth: "90px" }
        },
        {
            header: 'Amount Due', body: getDueAmount, style:{ textAlign: "center", minWidth: "90px" }
        },
        {
            header: 'Status', body: getVPStatus, style:{ textAlign: "center", minWidth: "100px" }
        },
        {
            header: 'Bank Details', field: '', body: getBankDetailsBody, style:{ textAlign: "center" }
        },
        {
            header: 'Purchase Invoice', field: '', style:{ textAlign: "center" }, body: getPurchaseInvBody
        },
        {
            header: 'VP Request', field: '', style:{ textAlign: "center" }, body: (row) => renderVendorPaymentRequestButton(row)
        }
    ]

    const actionMenuItems = [
        {
            label: 'Add Expense',
            icon: '',
            command: () => {
                setVisibleAddExpense(true)
            },
            permissions: [53]
        },
        {
            label: 'Download Payment Tracker',
            icon: '',
            command: () => {
                setVisiblePaymentTrackerModal(true)
            },
            visible: pmCompanyConfig.paymentTrackerUsed
        },
    ]

    const handlePIView = async (row) => {
        setIsPIVisible(true)
        setIsLoading(true)
        const sellerPIPunchRes = await getSellerPIPunchBySellerPOId({sellerPOId: row?.sellerPOId})

        if (sellerPIPunchRes?.failure){
            setIsLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "Seller PI Punch", detail: sellerPIPunchRes?.data?.error, life: 3000}))
        }else{
            const materialIds = sellerPIPunchRes?.data?.sellerPIPunchItems?.map(eachSellerPIPunchItem => eachSellerPIPunchItem?.materialId)
            const materialDetailsRes = await getMaterialMasterAndTempMaterialIds({materialIds: materialIds})

            if (materialDetailsRes?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: "Material Details", detail: materialDetailsRes?.data?.error, life: 3000}))
            }

            setSellerPIPunch(sellerPIPunchRes?.data?.sellerPIPunch)
            setSellerPIPunchItems(sellerPIPunchRes?.data?.sellerPIPunchItems)
            setPIPunchBookingLogs(sellerPIPunchRes?.data?.PIPunchBookingLogs)
            setMaterialDetails(materialDetailsRes?.data)
        }
        setIsLoading(false)
    }

    const handleHide = () => {
        setIsPIVisible(false)
        setSellerPIPunch([])
        setSellerPIPunchItems([])
        setMaterialDetails([])
    }

    const handlePageChange = async (e) => {
        let vendorPaymentParams = { 
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }
        if (vendorPaymentParams.searchBy !== "all") {
            vendorPaymentParams[vendorPaymentParams.searchBy] = vendorPaymentParams.searchText.trim()
        }
        dispatch(fetchSellerPOVendorPayments({...vendorPaymentParams }))
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }        

    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
    ]

    return (
        <div>
            <div className="vp-credit-non-credit-layout flex flex-column">
                <div className="flex flex-column md:flex-row md:justify-content-between">
                    <h4 className="mx-2 my-1 md:m-2">VENDOR PAYMENT</h4>
                    <div className="flex flex-row justify-content-between mb-2">
                        <div className="mr-2">
                            {/* <p>Selected Amount : {selectedVendorPaymentsAmount}</p> */}
                        </div>
                        <div className="mr-2 flex justify-content-end">
                            <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                            {/* <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                            <Button icon="pi pi-filter" className={`h-2rem ml-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                            <ButtonGroup buttons={actionButtons} />
                        </div>
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div className="vendor-payment-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                        <div className='p-card mb-0'>
                            <div className="flex-grow-1" >
                                <Table
                                    lazy
                                    page={paginationParams.pageNo}
                                    onPageChange={(e)=> handlePageChange(e)} 
                                    totalRecords={paginationParams.totalRecords}
                                    tableColumns={tableColumns}
                                    rows={paginationParams.recordsPerPage}
                                    data={sellerPOVendorPaymentsData}
                                    scrollable={"true"}
                                    scrollHeight="550px" 
                                    paginator
                                    excessPagesFound= {paginationParams.excessPagesFound}
                                    loading={isTableLoading}
                                />
                            </div>
                        </div>
                    </div>
                    {
                        isSearchVisible && !isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                            <Search expenseCategories={expenseCategories} />
                        </div>
                    }

                    {
                        isSearchVisible && isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                            <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                                <Search expenseCategories={expenseCategories} />
                            </Sidebar>
                        </div>
                    }

                    <Dialog header="Add Expense" className="add-expense-dialog" headerStyle={{ paddingBottom: "10px", paddingTop: "10px" }} contentStyle={{ backgroundColor: "#f8f9fa" }} visible={visibleAddExpense} style={{ width: '80vw', height: '80vh', backgroundColor: "#eeeff0" }} onHide={() => setVisibleAddExpense(false)}>
                        <AddExpense setVisibleAddExpense={setVisibleAddExpense} HSNMasterData={HSNMasterData} companyCreditPeriods={companyCreditPeriods} />
                    </Dialog>
                    <div className="pi-punch-modal">
                        <Dialog className="pi-history-dialog" visible={isPIVisible} onHide={() => handleHide()} style={{ backgroundColor: '#f8f8f8' }}>
                            <TabView>
                                <TabPanel  header="PI History" className="pi-details">
                                    <PIReceivedProductDetails 
                                        sellerPIPunch={sellerPIPunch} 
                                        sellerPIPunchItems={sellerPIPunchItems} 
                                        PIPunchBookingLogs={PIPunchBookingLogs} 
                                        materialDetails={materialDetails} 
                                        materialBrands={materialBrands} 
                                        forViewOnly={true} 
                                        isLoading={isLoading}
                                        processLineItems={[]}
                                        sellerPIPunchTickets={[]}
                                        ticketSubCategoies={[]}
                                        approvalInstances={[]}
                                    />
                                </TabPanel>
                            </TabView>
                        </Dialog>
                    </div>
                    <Dialog header="Bank Details" visible={isBankDetailsVisible} style={{ width: '60vw', height: '30vh' }} onHide={() => {setIsBankDetailsVisible(false); setDisplayedBankDetails([])}}>
                        <div className="ml-2 mr-2 mt-0 pt-0">
                            <div>
                                <div className="flex justify-content-between">
                                    <div className="flex flex-wrap py-2 w-full">
                                        <div className="flex justify-content-between flex-grow-1 font-bold header-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize:"14px" }}>
                                            <div className="mt-1" style={{ width: '20%' }}>Bank Name</div>
                                            <div className="mt-1" style={{ width: '20%' }}>Account Holder Name</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Account No</div>
                                            <div className="mt-1" style={{ width: '12%' }}>IFSC Code</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Document</div>
                                        </div>
                                        {
                                            displayedBankDetails?.map(eachBankDetails => {
                                                return (
                                                    <div className="flex justify-content-between flex-grow-1 w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px" }}>
                                                        <div className="py-1 align-self-center" style={{ width: '20%' }}>{eachBankDetails?.bankName}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '20%' }}>{eachBankDetails?.holderName}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachBankDetails?.accNo}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachBankDetails?.ifscCode}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>
                                                            { eachBankDetails?.documentProof ? <a href={ eachBankDetails.documentProof} target="_blank" >View</a> : "" }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>

                    <Dialog header="VENDOR PAYMENT HISTORY" visible={isVendorPaymentHistoryVisible} style={{ width: '75vw', minHeight: '30vh' }} onHide={() => {setIsVendorPaymentHistoryVisible(false); setDisplayedVendorPayments([])}}>
                        <div className="vendor-payment-summary-tab" style={{width: "100%", paddingLeft: "0%", paddingRight: "0%"}}>
                            <PaymentHistory vendorPayments={displayedVendorPayments} statusList={statusList} viewFlag={true} />
                        </div>
                    </Dialog>

                    <DownlaodPaymentTrackerModal visiblePaymentTrackerModal={visiblePaymentTrackerModal} setVisiblePaymentTrackerModal={setVisiblePaymentTrackerModal} />
                </div>
            </div>
        </div>
    )
}

export default VendorPayment;